import {
    Component,
    ViewChild,
    TemplateRef,
    ElementRef,
    ViewContainerRef,
    OnInit,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    Input,
    HostListener
} from '@angular/core';
import { fromEvent, debounceTime } from 'rxjs';
declare var google: any;

@Component({
    selector: 'app-google-charts-column-chart',
    templateUrl: './google-charts-column-chart.component.html',
    styleUrls: ['./google-charts-column-chart.component.scss'],
})
export class GoogleChartsColumnChartComponent
    implements OnInit, OnChanges, AfterViewInit
{
    @ViewChild('chartDiv', { static: false }) chartDivRef: ElementRef;
    @Input() chartData: any;
    @Input() chartOptions: any;
    chart: any;

    constructor(private container: ViewContainerRef) {
		fromEvent(window, 'resize')
        .pipe(debounceTime(500))
        .subscribe(() => this.createChart());
    }

    ngOnInit(): void {
        google.charts.load('current', { packages: ['corechart'] });
    }

    ngAfterViewInit(): void {
        //this.createChart();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.chartData && this.chartOptions) 
		{
            this.createChart();
        }
    }

    private createChart(): void {
        google.charts.setOnLoadCallback(() => {

            let responsiveChartOptions = { ... this.chartOptions};
    
            // if (window.innerWidth <= 992) {
            //     delete responsiveChartOptions['chartArea'];
            // }

            if (this.chartData && responsiveChartOptions) {
                this.chart = new google.visualization.ColumnChart(
                    this.chartDivRef?.nativeElement
                );
                this.chart.draw(this.chartData ?? [], responsiveChartOptions);
                google.visualization.events.addListener(this.chart, 'ready', this.setChartZoom());

            }

        });
    }

    private setChartZoom(): void {
        //console.log('hit setChartZoom function');
    }
}
